import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

import AdminAPI from '@/api/AdminAPI'
import AuthAPI from '@/api/AuthAPI'

Vue.use(Vuex)

const vuexPersist = new VuexPersist({
  storage: window.localStorage,
})

export default new Vuex.Store({
  state: {
    user: null,
    accessToken: null,
    refreshToken: null,
  },

  getters: {
    user(state) {
      return state.user
    },

    isLoggedIn(state) {
      return Boolean(state.user)
    },

    accessToken(state) {
      return state.accessToken
    },

    refreshToken(state) {
      return state.refreshToken
    },
  },

  mutations: {
    resetState(state) {
      state.user = null
      state.accessToken = null
      state.refreshToken = null
    },

    setUser(state, user) {
      state.user = user
    },

    setAccessToken(state, accessToken) {
      state.accessToken = accessToken
    },

    setRefreshToken(state, refreshToken) {
      state.refreshToken = refreshToken
    },
  },

  actions: {
    signIn(Store, data) {
      return AuthAPI.signIn(data)
        .then(({
          user,
          accessToken,
          refreshToken,
        }) => {
          Store.commit('setUser', user)
          Store.commit('setAccessToken', accessToken)
          Store.commit('setRefreshToken', refreshToken)
        })
    },

    signOut(Store) {
      return AdminAPI.signOut()
        .then(() => Store.commit('resetState'))
        .catch(() => Store.commit('resetState'))
    },

    refreshAccessToken(Store) {
      return AuthAPI.issueAccessToken(Store.state.refreshToken)
        .then(accessToken => Store.commit('setAccessToken', accessToken))
        .catch(() => Store.commit('resetState'))
    },
  },

  plugins: [
    vuexPersist.plugin,
  ],
})
